import { render, staticRenderFns } from "./VehicleLogsView.vue?vue&type=template&id=22f283c7&"
import script from "./VehicleLogsView.vue?vue&type=script&lang=js&"
export * from "./VehicleLogsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VDataTable})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22f283c7')) {
      api.createRecord('22f283c7', component.options)
    } else {
      api.reload('22f283c7', component.options)
    }
    module.hot.accept("./VehicleLogsView.vue?vue&type=template&id=22f283c7&", function () {
      api.rerender('22f283c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Vehicles/Views/VehicleLogsView.vue"
export default component.exports